import React from "react";
import { FileUploader } from "react-drag-drop-files";
import { useTheme } from "styled-components";

import { FileWrapper, FileDropArea } from "./file.style";
import cloudUpload from "../../../assets/icons/cloud_upload.svg";
import { Button } from "@mbo/forms";

const File = ({ handleChange, accept, bottomMessage, dropAreaText }) => {
  const { colors } = useTheme();

  return (
    <FileWrapper>
      <FileUploader
        handleChange={handleChange}
        types={accept}
        onTypeError={() => alert("Chosen file has wrong type")}
        maxSize={10}
        onSizeError={() => alert("File size is too large")}
        dropMessageStyle={{
          backgroundColor: colors.secondaryBackgroundLightTint20,
        }}
        hoverTitle=" "
      >
        <FileDropArea>
          <img src={cloudUpload} alt="cloud upload icon" />
          <p>{dropAreaText || "Drag and drop source document"}</p>
          <Button variant="primary" round size="lg">
            Select file
          </Button>
        </FileDropArea>
      </FileUploader>
      <p>{bottomMessage}</p>
    </FileWrapper>
  );
};

export default File;
